import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function InsuranceReinsuranceLicenseSeychelles() {

    return (
        <main className='main'>

            <IntroSection
                title="Insurance & Reinsurance License – Seychelles"
                subtitle="Establish Insurance, Reinsurance, and Captive Companies in the Indian Ocean"
                description="
                <b>Seychelles</b> provides a <b>robust legal and regulatory framework</b> for <b>insurance and reinsurance firms</b>, licensed and supervised by the <b>Financial Services Authority (FSA)</b>.
                <br/>
                The jurisdiction is especially attractive for <b>captive insurance structures</b>, <b>general insurers</b>, and <b>reinsurers</b> targeting <b>African</b>, <b>Asian</b>, and <b>international markets</b>.

                "
                badges={
                    [
                        "Captive Insurance",
                        "General Insurance",
                        "Life Insurance",
                        "Reinsurance"
                    ]
                }
                buttonText="Request a Seychelles Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt="image"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Seychelles for Insurance?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Respected Regulator",
                                                text: "FSA oversight ensures international credibility."
                                            },
                                            {
                                                title: "Flexible Structures",
                                                text: "Captive, life, general, and reinsurance firms."
                                            },
                                            {
                                                title: "Strategic Location",
                                                text: "Gateway between Africa, Asia, and Europe."
                                            },
                                            {
                                                title: "Competitive Capital",
                                                text: "Much lower entry thresholds than EU/US regimes."
                                            },
                                            {
                                                title: "Tax Neutrality",
                                                text: "Foreign-sourced premiums are exempt from Seychelles tax."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Insurance Licenses in Seychelles"
                        blocks={[
                            {
                                title: "Captive Insurance",
                                items: [
                                    { text: "Corporations insure their own risks." },
                                    { text: "Popular for shipping, energy, and multinational firms." },
                                    { text: "Lower compliance and lighter capital requirements." }
                                ]
                            },
                            {
                                title: "General Insurance",
                                items: [
                                    { text: "Covers property, liability, casualty, and specialty lines." },
                                    { text: "Requires higher solvency reporting." }
                                ]
                            },
                            {
                                title: "Life Insurance",
                                items: [
                                    { text: "Covers health, personal, and group life products." },
                                    { text: "Heavier actuarial and reporting obligations." }
                                ]
                            },
                            {
                                title: "Reinsurance Companies",
                                items: [
                                    { text: "Provide reinsurance capacity to insurers and reinsurers globally." },
                                    { text: "Strategic hub for regional and global reinsurers." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Captive Insurance",
                                    text: "USD 100,000 minimum."
                                },
                                {
                                    title: "General Insurance",
                                    text: "USD 150,000–200,000."
                                },
                                {
                                    title: "Life Insurance",
                                    text: "USD 200,000."
                                },
                                {
                                    title: "Reinsurance Companies",
                                    text: "USD 250,000+."
                                },
                                {
                                    title: "Additional Requirements",
                                    text: "Seychelles entity incorporation; fit & proper directors/shareholders; local office or agent; AML/KYC and solvency reporting."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Seychelles Insurance License'
                        services={
                            [
                                {
                                    title: "International Recognition",
                                    text: "Higher standing than many smaller offshore jurisdictions."
                                },
                                {
                                    title: "Cost-Effective Entry",
                                    text: "Lower capital requirements vs Bermuda and EU markets."
                                },
                                {
                                    title: "Versatile Licensing",
                                    text: "Supports captives, general, life, and reinsurance companies."
                                },
                                {
                                    title: "Asset Protection & Risk Management",
                                    text: "Trusted by multinational corporations."
                                },
                                {
                                    title: "Regional Advantage",
                                    text: "Gateway to Africa and Asia’s growing insurance markets."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Choose license type: captive, general, life, or reinsurance."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Set up a Seychelles IBC or local entity."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Includes actuarial support, compliance manuals, and financial planning."
                                },
                                {
                                    title: "FSA Review",
                                    text: "Regulator performs due diligence and solvency checks."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically completed in 6–9 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–9 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "From USD 60,000+ (legal, actuarial, compliance)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "USD 100k–250k depending on license type."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "FSA fees, audits, actuarial reporting."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Specialists in insurance and reinsurance licensing."
                                },
                                {
                                    text: "End-to-end support: structuring, license applications, compliance manuals."
                                },
                                {
                                    text: "Strong network of actuaries, auditors, and reinsurance partners."
                                },
                                {
                                    text: "Comparative insights: Seychelles vs St Lucia vs Malta vs Bermuda."
                                },
                                {
                                    text: "Ongoing compliance and solvency support with the FSA."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to establish an insurance, reinsurance, or captive company?"
                        description="Seychelles offers competitive capital requirements, FSA supervision, and global recognition."
                        buttonText="Book a Seychelles Insurance Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What’s the capital requirement for captives in Seychelles?",
        content: [
            { type: "answer", text: "USD 100,000." },
        ],
    },
    {
        question: "Does Seychelles license reinsurance companies?",
        content: [
            { type: "answer", text: "Yes — with minimum capital of USD 250k." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 6–9 months." },
        ],
    },
    {
        question: "Can Seychelles insurance companies operate internationally?",
        content: [
            { type: "answer", text: "Yes — especially in Africa, Asia, and global markets." },
        ],
    },
    {
        question: "Why choose Seychelles over Bermuda or Cayman?",
        content: [
            { type: "answer", text: "Lower costs and capital, but still FSA-regulated." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We set up a captive in Seychelles with Offshore Advisory. The FSA licensing was smooth and efficient.",
        author: "Jonathan K., Corporate Risk Manager",
    },
    {
        quote: "Seychelles gave us a cost-effective base for our reinsurance company. Offshore Advisory managed compliance and actuarial filings.",
        author: "Maria P., Reinsurance Director",
    },
];

